const state = {
  queryObject: undefined,
  headerTitle: undefined,
  hideHeader: false,
  authData: false
};

const getters = {
  queryObject: (state) => state.queryObject,
  headerTitle: (state) => state.headerTitle,
  hideHeader: (state) => state.hideHeader,
  authData: (state) => state.authData,
};

const actions = {
  setQueryObject({commit}, queryObject) {
    commit('setQueryObject', queryObject);
  },
  setHeaderTitle({commit}, title) {
    commit('setHeaderTitle', title);
  },
  setAuthData({commit}, authData) {
    commit('setAuthData', authData);
  },
  iTriglavLogout() {
    window.localStorage.removeItem('pobr-auth');
    window.open(`https://${process.env.VUE_APP_ITRIGLAV_ROOT_URL}/TriglavLogin/odjava`, '_self');
  }
};

const mutations = {
  setQueryObject(state, queryObject) {
    state.hideHeader = queryObject.wv === 'true';
    state.queryObject = queryObject;
  },
  setHeaderTitle(state, title) {
    state.headerTitle = title;
  },
  setAuthData(state, authData) {
    state.authData = authData;
  }
};

export const POBRStoreModule = {
  state, getters, actions, mutations
}
